<div class="background" [ngClass]="{closing: closing}"></div>

<div class="popup" >
	<div class="container" [ngClass]="{closing: closing, error: error, white: variation == 'white'}">
		<p *ngIf="variation == 'white'" class="close" (click)="close()">&times;</p>
		<div class="contents">
			<ng-content></ng-content>
			<p *ngIf="variation != 'white'" class="close" (click)="close()">OK</p>
		</div>
	</div>
</div>
